import { useEffect } from 'react';
import { Alert } from '@nimbus-ds/components';
import { Text } from '@tiendanube/components';
import {
  useHasSubscriptionsFeatureEnabled,
  useSubscriptionsTranslation,
} from 'domains/Subscriptions';

function SubscriptionAlert() {
  const { hasFeatureEnabled, fetchHasFeatureEnabled } =
    useHasSubscriptionsFeatureEnabled();

  useEffect(() => {
    fetchHasFeatureEnabled();
  }, [fetchHasFeatureEnabled]);

  const t = useSubscriptionsTranslation('payments.advancedSettings');
  return (
    <Alert show={hasFeatureEnabled} title={t('title')} appearance="warning">
      <Text>{t('description')}</Text>
    </Alert>
  );
}

export default SubscriptionAlert;
